import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { CONTACT_US_PAGE_META, EMAIL_BREADCRUMBS, EMAIL_ENQUIRY_STATUS } from 'lib/enums/contactUs';
import Breadcrumbs from 'components/Breadcrumbs';
import PageBlock from 'components/PageBlock';
import EnquiryForm from './EnquiryForm';
import Header from 'pages/ContactUs/Header';
import ErrorBanner from './EnquiryForm/ErrorBanner';
import EnquiryConfirmationMessage from './EnquiryForm/EnquiryConfirmationMessage';
import { getStatus } from 'store/enquiry/enquirySelectors';

const EnquiryLayout = ({ pageTitle }) => {
  const queryStatus = useSelector(getStatus);
  const isComplete = queryStatus === EMAIL_ENQUIRY_STATUS.COMPLETE;
  const hasError = queryStatus === EMAIL_ENQUIRY_STATUS.ERROR;

  return (
    <Fragment>
      <Helmet meta={CONTACT_US_PAGE_META} title={pageTitle} />
      <PageBlock bg="white" py={10} px={[4, 6, 0]} data-print-style="page-block">
        <Breadcrumbs context="Contact Us" crumbs={EMAIL_BREADCRUMBS} />
      </PageBlock>
      <Header
        pb={10}
        title="Email us"
        description="Get in touch with our team if you have questions about your Qantas Hotels booking, would like to give feedback about your experience and more."
      />

      {hasError && <ErrorBanner />}
      {isComplete ? <EnquiryConfirmationMessage /> : <EnquiryForm />}
    </Fragment>
  );
};

EnquiryLayout.propTypes = {
  pageTitle: PropTypes.string,
};

EnquiryLayout.defaultProps = {
  pageTitle: 'Contact us | Qantas Hotels Australia',
};

export default EnquiryLayout;
